import { Component, Input, OnInit } from '@angular/core';
import { CarFilterOptions } from 'src/app/models/car-filter-options.model';
import { ComponentStatus } from 'src/app/models/component-status.model';
import { LabchComponentStatusView } from 'src/app/models/labch-component-status-view.model';
import { CarReportService } from 'src/app/services/car-report/car-report.service';
import { DifferenceType } from 'src/app/shared/enums/difference-type.enum';
import { Car } from 'src/app/models/car.model';
import {DecimalPipe, NgClass, NgStyle} from "@angular/common";
import {LabelChartType} from "../../../shared/pipes/label-chart-type.pipe";
import {DeltaValuesCssClassPipe} from "../../../pipes/delta-values-css-class/delta-values-css-class.pipe";
import {TranslateModule} from "@ngx-translate/core";
import {ComponentStatusCssClassPipe} from "../../../pipes/component-status-css-class/component-status-css-class.pipe";
import {MatCard, MatCardTitle} from "@angular/material/card";
import {MatIcon} from "@angular/material/icon";
import {KpiLabelPipe} from "../../../shared/pipes/kpi-label.pipe";
import {MatTable, MatColumnDef, MatHeaderCell,MatCell,MatHeaderCellDef,MatCellDef,MatHeaderRow,MatRow,MatHeaderRowDef,MatRowDef} from "@angular/material/table";

@Component({
  selector: 'colimo-car-report-labch-statistics',
  templateUrl: './car-report-labch-statistics.component.html',
  styleUrls: ['./car-report-labch-statistics.component.scss'],
  imports: [
    DecimalPipe,
    LabelChartType,
    NgClass,
    DeltaValuesCssClassPipe,
    TranslateModule,
    ComponentStatusCssClassPipe,
    MatCardTitle,
    MatCard,
    NgStyle,
    MatIcon,
    KpiLabelPipe,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef
  ]
})
export class CarReportLabchStatisticsComponent implements OnInit {
  @Input() public car: Car;
  @Input() public componentsStatus: ComponentStatus[];
  @Input() public filterOptions: CarFilterOptions;
  @Input() public selectedComponentStatus: ComponentStatus;
  @Input() public componentStatusCount: number;
  @Input() public heading: string;
  @Input() public labchBumperAverageHeading: string;
  @Input() public componentTranslations: string[];
  @Input() public positionTranslations: string[];

  public differenceType: DifferenceType;
  public displayedColumns: string[];
  public labchStatisticDataSource: LabchComponentStatusView[];

  constructor(private carReportService: CarReportService) {}

  public ngOnInit(): void {
    if (this.componentsStatus) {
      this.labchStatisticDataSource = this.carReportService.buildLabchStatisticDataSource(
        this.componentsStatus,
        this.componentStatusCount,
      );
    }
    this.displayedColumns = [
      'id',
      'component',
      'position',
      'status',
      'geometry',
      'dl',
      'da',
      'db',
      'dc',
      'dh',
      'de',
      'mde',
    ];
  }
}
